import { createActions } from 'redux-actions';
import { GetInsurancePolicyUserParams } from '@apis/InsurancePolicyUserApi';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';

export type State = {
  policyUser?: InsurancePolicyUser | null;
};

export type InsurancePolicyUserFetchPayload = GetInsurancePolicyUserParams;
export type StateUpdatePayload = Partial<State>;

export const {
  insurancePolicyUserFetch,
  stateUpdate,
} = createActions(
  'INSURANCE_POLICY_USER_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_INSURANCE_POLICY_USER_DETAILS_PAGE',
  },
);
